import { Navigate, useLocation } from "react-router-dom";
import { portalPathToShell } from "./portalPathToShell";

export const PortalShellRedirect = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${portalPathToShell(pathname)}${search}${hash}`} replace />;
};
